import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { DataStorageService } from '../../shared/data-storage.service';
import { Router } from '@angular/router';
import { ErrorClass } from '../../error/error-class';
import {
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
    HttpHandler,
    HttpEvent,
    HttpErrorResponse
} from '@angular/common/http';

import { LoaderService } from '../../loader/loader.service';
import { InfoService } from '../../info/info-service';
import { EkpayUser } from '../../user/ekpay_user';
import { Subscription } from 'rxjs';
import { EncryptInterceptor } from './EncryptInterceptor';
import { ResponseIntercept } from './RespnseIntercept';
import { AccountService } from '../../shared/auth/account.service';
declare var AesUtil: any;
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    respIntercpt: ResponseIntercept;
    constructor(
        private localStorage: LocalStorageService,
        private sessionStorage: SessionStorageService,
        private dataStorageService: DataStorageService,
        private router: Router,
        private infoService: InfoService,
        private loaderService: LoaderService,
        private accountService: AccountService,

    ) { }
    reqBody: string;
    user: EkpayUser;
    userAcc:EkpayUser;
    serviceUser: EkpayUser;
    encryptInter: EncryptInterceptor;
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        console.log('AuthInterceptor called...');
        const token = this.localStorage.retrieve('authenticationToken') || this.sessionStorage.retrieve('authenticationToken');
        const sessionToken = this.sessionStorage.retrieve('sessionToken');
        console.log('token... ' + token);
        console.log('session token' + sessionToken);
        let customReq = null;

        this.user = JSON.parse(localStorage.getItem("sessuser")) as EkpayUser;
        this.dataStorageService.userData$.subscribe((data) => {
            this.serviceUser = data as EkpayUser;
            if (this.user != null && this.serviceUser != null && (this.user.ekpay_id != this.serviceUser.ekpay_id)) {
                location.reload();
            }

        })
        if (request.body != null) {
            //if (this.router.url.includes("/login")) {
            console.log('processing request >>>>', request.body);
            var str = JSON.stringify(request.body);
            var str1 = str.replace(/\\/g, '');
            if (str1.startsWith("\"")) {
                this.reqBody = str1.substring(1, str1.length - 1)
            } else {
                this.reqBody = str1;
            }
            console.log('>>>>> string version is', this.reqBody);
            var iterationCount = 1000;
            var keySize = 128;
            var aesUtil = new AesUtil(keySize, iterationCount);
            var encString1 = aesUtil.encrypt("8bc82ffe516ea1f1b89dcb529a201d56", "ebb7947b5feabdc0b60f2a694fa259c4", "Gr33nL!ght#D91", this.reqBody);
            console.log(encString)
            console.log('encrypted string is >>>>' + JSON.stringify(encString));
            var encString = "";
            if(request.url.includes("/patron/access/fetch-bill")){
              encString = this.reqBody;
            }else{
              encString = "{\"mnbvcxzlkjhgfdsapoiuytrewq\":\"" + encString1 + "\"}";
            }
            // encString = "{\"mnbvcxzlkjhgfdsapoiuytrewq\":\"" + encString1 + "\"}";
            // }
        }

        if (this.user == null) {
            this.dataStorageService.setUserData(null);
        }
        if (sessionToken != null) {
            customReq = request.clone({
                headers: request.headers.set('Authorization', 'Bearer ' + token).set('Content-Type', 'application/json').set('x-auth-token', sessionToken),
                body: encString
            });
        } else {
            customReq = request.clone({
                headers: request.headers.set('Authorization', 'Bearer ' + token).set('Content-Type', 'application/json'),
                body: encString
            });
        }
        return next
            .handle(customReq).map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    // change the response body here
                    // console.log('event.body>>', event.body);
                    // var obj = JSON.parse(event.body);
                    // event = event.clone({
                    //   body: JSON.parse(obj)
                    // });
                    //
                    // console.log('this.respIntercpt>>>>>>>>>', event.body.qwertyuiopasdfghjklzxcvbnm);
                    // if (event.body.qwertyuiopasdfghjklzxcvbnm != undefined) {
                    //     console.log('processing response >>>>', JSON.stringify(event.body));
                    //     var iterationCount = 1000;
                    //     var keySize = 128;
                    //     var aesUtil = new AesUtil(keySize, iterationCount);
                    //     var ciphertext2 = aesUtil.decrypt("8bc82ffe516ea1f1b89dcb529a201d56", "ebb7947b5feabdc0b60f2a694fa259c4", "Gr33nL!ght#D91", event.body.qwertyuiopasdfghjklzxcvbnm);
                    //     console.log('ciphertext2 is >>>>' + JSON.stringify(ciphertext2));
                    //     // return ev.clone({
                    //     //     body: ciphertext2
                    //     // });
                    //     event = event.clone({
                    //         body: JSON.parse(ciphertext2)
                    //     });
                    // }


                }
                return event;
            }).do((ev: HttpEvent<any>) => {
                if (ev instanceof HttpResponse) {

                    const sessioToken = ev.headers.get('x-auth-token');
                    if (sessioToken != null) {
                        this.sessionStorage.store("sessionToken", ev.headers.get('x-auth-token'));
                        // alert(sessioToken);
                    }
                    console.log('processing response', ev);
                }

            },
                (err: HttpErrorResponse) => {
                    console.log('err obj is>>>>' + JSON.stringify(err));
                    if (err.error instanceof Error) {
                        // A client-side or network error occurred. Handle it accordingly.

                        console.log('An error occurred:', err.error.message);
                    } else {
                        // The backend returned an unsuccessful response code.
                        // The response body may contain clues as to what went wrong,
                        console.log(`Backend returned code ${err.status}, body was: ${err.error}`);
                        console.log("err.error" + JSON.stringify(err.error));
                    }
                    this.dataStorageService.storage = new ErrorClass(err.name, err.status, err.message, '');

                    if (err.status == 503) {
                        this.infoService.header = "Oh!";
                        this.infoService.message = "Service is down for required maintenance right now. Please try after some time.";
                        this.loaderService.hide();
                        this.router.navigate(['info']);
                    }
                    // alert(err.error.AuthenticationException);
                    if (err.status == 401 && err.error.AuthenticationException != 'Bad credentials') {
                        this.infoService.header = "Oops!";
                        this.infoService.message = "Your session has expired";
                        this.dataStorageService.setUserData(null);
                        this.loaderService.hide();
                        // this.router.navigate(['info']);
                    }
                    if (err.status != 401 && this.router.url != 'login') {
                        if (err.status == 404) {
                            this.router.navigate(["/home"]);
                        } else {
                            this.infoService.header = "Oh!";
                            this.infoService.message = "Service is down for required maintenance right now. Please try after some time."
                            this.loaderService.hide();
                            let link = ['/info'];
                            this.router.navigate(link);
                        }
                    }
                });
    }


    // requestIntercept(options?: RequestOptionsArgs): RequestOptionsArgs {
    //     return options;
    // }

    // responseIntercept(observable: Observable<Response>) {
    //     alert('hi');
    // }
}



// WEBPACK FOOTER //
// ./src/app/blocks/interceptor/auth.interceptor.ts